import { Button, Dropdown } from "antd";
import { useState } from "react";

import dotsGridIcon from "./assets/dots-grid.svg";

import "./ServicesMenu.css";

export interface ServicesMenuItem {
  key: string;
  icon: string;
  href: string;
  title: string;
  authHref?: string;
  description: string;
}

export interface ServicesMenuProps {
  items: ServicesMenuItem[];
  isLoggedIn?: boolean;
}

function ServiceMenuItem({
  icon,
  href,
  title,
  authHref,
  isLoggedIn,
  description,
  onClick,
}: ServicesMenuItem & { isLoggedIn: boolean; onClick: () => void }) {
  const resolvedHref = isLoggedIn && authHref ? authHref : href;
  const isExternal = resolvedHref.startsWith("http");

  return (
    <a
      className="services-menu__item"
      href={resolvedHref}
      target={isExternal ? "_blank" : "_self"}
      rel={isExternal ? "noopener noreferrer" : undefined}
      onClick={onClick}
    >
      <img src={icon} width={22} height={22} alt="" />
      <div className="services-menu__item-text">
        <span className="services-menu__item-title">{title}</span>
        <span className="services-menu__item-desc">{description}</span>
      </div>
    </a>
  );
}

export function ServicesMenu({ items, isLoggedIn = false }: ServicesMenuProps) {
  const [open, setOpen] = useState(false);

  const overlay = (
    <div className="services-menu__dropdown">
      {items.map(({ key, ...itemProps }) => (
        <ServiceMenuItem
          key={key}
          isLoggedIn={isLoggedIn}
          {...itemProps}
          onClick={() => setOpen(false)}
        />
      ))}
    </div>
  );

  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      popupRender={() => overlay}
      placement="bottomRight"
      align={{ offset: [0, 22] }}
      trigger={["click"]}
    >
      <Button
        type="text"
        className="services-menu__button"
        style={{
          backgroundColor: "transparent",
          padding: 0,
          width: "auto",
          height: "auto",
          lineHeight: 1,
        }}
        icon={
          <img src={dotsGridIcon} width={22} height={22} aria-hidden="true" />
        }
      />
    </Dropdown>
  );
}
